import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIList } from "config/apiList";
import { baseUrl } from "config/defaultUrl";
import axios from "utils/axios";

export const getCompaniesThunk = createAsyncThunk(
  "recommendation/getCompanies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        baseUrl + APIList.getAllrecommendationCompanies
      );
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "API Error");
    }
  }
);

export const getProductsByCompanyThunk = createAsyncThunk(
  "recommendation/getProductsByCompany",
  async (companyId: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        baseUrl + APIList.getProductsByCompany(companyId)
      );
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "API Error");
    }
  }
);

export const getProductsDataByProductId = createAsyncThunk(
  "recommendation/getProductsDataByProductId",
  async (
    { productId }: { productId: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        baseUrl + APIList.getProductsDataByProductId(productId)
      );
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "API Error");
    }
  }
);

